// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","PageTitle":"PageTitle_PageTitle__3GkWv"};